<template>
    <div v-observe-visibility="{
        callback: visibilityChanged,
        once: true,
        options: {
            threshold: 0.0,
        }
    }">
        <div class="ggame-heading lb-sport"
        :class="getGameHeadingClass"
        v-if="item.specialTournament">
            <span v-if="sportMapping[item.tournamentId] !== undefined"
            class="ggame-heading-icon sport-icon lb-sport"
            :class="getSportIconClass(item.tournamentId)"></span>
            <h2 class="ggame-heading-text">{{item.tournamentName}}</h2>
        </div>
        <div class="ggame-heading lb-sport"
        :class="'sportbordercolor-' + sportMapping[item.sportId]"
        v-else>
            <span class="ggame-heading-icon sport-icon lb-sport" :class="getSportIconClass(item.sportId)"></span>
            <h2 class="ggame-heading-text">
                {{  item.categoryName }} - {{ item.tournamentName }}
            </h2>
            <div class="dropdown-select-box" @click.stop="$emit('openMarkets', item.tournamentId)" >
                <p class="ddselect-text" :class="{active: item.oddSelectBox}"><span>{{getMarketNames(item)}}</span>
                    <i class="iconset icon-checkticket"></i>
                </p>
            </div>
        </div>
        <template v-if="tournamentVisible">
            <template v-for="marketId in marketIds">
                <div :key="marketId" v-if="markets[marketId] && markets[marketId].matches && markets[marketId].matches.length">
                    <div class="ggame-odds-heading" v-if="marketId !== 'favourites'">
                        <div class="ggame-odds-lheading" v-if="marketId != null && marketId !== 'null'">
                            <template v-if="marketId === 'bonus1'">
                                {{$t('BONUSONEMARKETNAME')}}
                            </template>
                            <template v-else-if="marketId === 'bonus2'">
                                {{$t('BONUSTWOMARKETNAME')}}
                            </template>
                            <template v-else>
                                {{
                                    getMarketName(marketId, 'marketSelectorTab')
                                }}
                            </template>
                        </div>
                        <div class="ggame-odds-lheading" v-else>-</div>
                    </div>
                    <!-- show outright right after it matches with tournamentId  -->
                    <template v-for="match in markets[marketId].matches">
                        <div class="ggame-item" v-if="matchesIn[match.matchId]" :match-id="match.matchId" :class="{'live': sportState == 'live', 'is-blocked': (matchesIn[match.matchId].status == 'block' || globalEventBlock[sportState])}" :key="match.matchId" v-on:click.prevent="$emit('selectMatch', match.matchId)" :ref_testcafe="(matchesIn[match.matchId].status == 'block' ) ? '' : 'activeTournament'">
                            <div class="ggame-item-content" v-for="(group, g) in match.groups" :key="g">
                                <div v-if="sportState == 'prematch'" class="ggame-item-text">
                                    <div class="ggame-item-left">
                                        <div class="ggame-inner-top">
                                            <span v-if="item.specialTournament"
                                            class="ggame-heading-icon sport-icon lb-sport"
                                            :class="getSportIconClass(matchesIn[match.matchId].sportId)">
                                            </span>
                                            <div class="ggame-item-teams">
                                                <span class="first-team">{{matchesIn[match.matchId].teamNameOne || 'not defined'}} - {{matchesIn[match.matchId].teamNameTwo || 'not defined'}}</span>
                                            </div>
                                        </div>
                                        <div class="ggame-inner-bottom">

                                            <span class="ggame-item-matchid">{{matchesIn[match.matchId].code}}</span>
                                            <span class="ggame-item-date">{{$predefinedLocalDateFormat(matchesIn[match.matchId].matchDate)}}</span>
                                            <span class="ggame-item-oddscount">+{{matchesIn[match.matchId].counts.markets}}</span>
                                            <div class="ggame-live-stream" v-if="matchesIn[match.matchId].stream && matchesIn[match.matchId].stream !== 'nostream'">
                                                <i class="iconset icon-stream" ></i>
                                                <div class="pulse" v-if="matchesIn[match.matchId].stream === 'live'" ></div>
                                            </div>
                                            <!-- img src="../../../assets/img/tv-stream-light.svg" alt="" class="ggame-mob-streams-icon"
                                            v-if="matchesIn[match.matchId].hasStream" -->
                                            <!-- img src="../../../assets/img/live-light.svg" alt="" class="ggame-mob-streams-icon" -->

                                        </div>
                                    </div>

                                    <div class="match-icons">
                                        <div v-if="sportState != 'live' && doesMatchHaveOutright(match.matchId)" class="match-outrights-icon"><!-- TODO icons are too close -->
                                            <img src="../../../assets/img/icon-outrights.svg">
                                        </div>
                                        <div class="event-icons">
                                            <FavouriteToggle :match="matchesIn[match.matchId]" @favouritetoggled="favouritetoggled" />
                                        </div>
                                        <div class="odd-stats"
                                        v-if="showOddStats && matchesIn[match.matchId] != null && matchesIn[match.matchId].sConn != null && matchesIn[match.matchId].sConn.match != null && matchesIn[match.matchId].sConn.match['1'] != null"
                                        @click.stop="openBetradarStatsPage(matchesIn[match.matchId])">
                                            <i class="iconset icon-statistic"></i>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="ggame-item-text"
                                :class="getEventLineClasses(matchesIn[match.matchId])">
                                    <div class="ggame-item-left" v-if="!isMobile">
                                        <div class="ggame-time">
                                            <div class="ggame-live-time">
                                                {{
                                                    getLiveMinutes(matchesIn[match.matchId])
                                                }}
                                            </div>
                                            <div class="ggame-live-stream" v-if="matchesIn[match.matchId].stream && matchesIn[match.matchId].stream !== 'nostream'">
                                                 <div class="icon-stream-booked">
                                                    <i class="iconset icon-stream"></i>
                                                    <div class="pulse" v-if="matchesIn[match.matchId].stream === 'live'"></div>
                                                 </div>
                                            </div>
                                        </div>
                                        <div class="ggame-teams">
                                            <div class="ggame-live-team">
                                                {{
                                                    matchesIn[match.matchId].teamNameOne
                                                    || 'not defined'
                                                }} <span
                                                    class="sport-icon lb-sport"
                                                    :class="getServeClass(matchesIn[match.matchId])"
                                                    v-if="
                                                    matchesIn[match.matchId]
                                                    .metaData.tServ !== undefined
                                                    && matchesIn[match.matchId].metaData.tServ === 1">
                                                    </span>
                                            </div>
                                            <div class="ggame-live-team">
                                                {{
                                                    matchesIn[match.matchId].teamNameTwo
                                                    || 'not defined'
                                                }} <span
                                                    class="sport-icon lb-sport"
                                                    :class="getServeClass(matchesIn[match.matchId])"
                                                    v-if="
                                                    matchesIn[match.matchId]
                                                    .metaData.tServ !== undefined
                                                    && matchesIn[match.matchId].metaData.tServ === 2">
                                                    </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="event-icons">
                                        <div class="ggame-score" v-if="!isMobile && matchesIn[match.matchId]
                                                .metaData">
                                            <div class="ggame-live-team-score">
                                                <div class="team-score-item current-score"
                                                v-if="matchesIn[match.matchId]
                                                .metaData.t1GemScr !== undefined
                                                && matchesIn[match.matchId].metaData.t1GemScr !== null">
                                                    {{
                                                        formatScore(
                                                            match,
                                                            matchesIn[match.matchId].metaData.t1GemScr,
                                                        )
                                                    }}
                                                </div>
                                                <div class="team-score-item" v-if="matchesIn[match.matchId].metaData.t1Scr != undefined">
                                                    {{matchesIn[match.matchId].metaData.t1Scr}}
                                                </div>
                                                <div class="team-score-item" v-for="(period, p) in matchesIn[match.matchId].metaData.periods" :key="p">
                                                    {{period.t1Scr}}
                                                </div>
                                            </div>
                                            <div class="ggame-live-team-score">
                                                <div class="team-score-item current-score"
                                                v-if="matchesIn[match.matchId]
                                                .metaData.t2GemScr !== undefined
                                                && matchesIn[match.matchId].metaData.t2GemScr !== null">
                                                    {{
                                                        formatScore(
                                                            match,
                                                            matchesIn[match.matchId].metaData.t2GemScr,
                                                        )
                                                    }}
                                                </div>
                                                <div class="team-score-item" v-if="matchesIn[match.matchId].metaData.t2Scr != undefined">
                                                    {{matchesIn[match.matchId].metaData.t2Scr}}
                                                </div>
                                                <div class="team-score-item" v-for="(period, p) in matchesIn[match.matchId].metaData.periods" :key="p">
                                                    {{period.t2Scr}}
                                                </div>
                                            </div>
                                        </div>
                                        <FavouriteToggle :match="matchesIn[match.matchId]" @favouritetoggled="favouritetoggled" v-if="!isMobile"/>
                                    </div>

                                    <div v-if="isMobile && matchesIn[match.matchId]
                                            .metaData" class="mobile-live-overview">
                                        <div class="ggame-item-left">
                                            <div class="ggame-time">
                                                <div class="ggame-live-time">{{getLiveMinutes(matchesIn[match.matchId])}}</div>
                                                <!--span class="ggame-item-oddscount">+{{matchesIn[match.matchId].counts.markets}}</span-->
                                            </div>
                                            <div class="ggame-teams">
                                                <div class="ggame-live-team">
                                                {{
                                                    matchesIn[match.matchId].teamNameOne || 'not defined'
                                                }} <span
                                                    class="sport-icon lb-sport"
                                                    :class="getServeClass(matchesIn[match.matchId])"
                                                    v-if="matchesIn[match.matchId]
                                                    .metaData && matchesIn[match.matchId]
                                                    .metaData.tServ !== undefined
                                                    && matchesIn[match.matchId].metaData.tServ === 1"
                                                    ></span>
                                                </div>
                                                <div class="ggame-live-team">
                                                {{
                                                    matchesIn[match.matchId].teamNameTwo || 'not defined'
                                                }} <span
                                                        class="sport-icon lb-sport"
                                                    :class="getServeClass(matchesIn[match.matchId])"
                                                        v-if="matchesIn[match.matchId]
                                                    .metaData && matchesIn[match.matchId]
                                                        .metaData.tServ !== undefined
                                                        && matchesIn[match.matchId]
                                                        .metaData.tServ === 2">
                                                        </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="matchesIn[match.matchId]
                                            .metaData" class="ggame-score">
                                            <div class="ggame-live-scores">
                                                <div class="ggame-live-team-score">
                                                <div class="team-score-item current-score"
                                                v-if="matchesIn[match.matchId]
                                                .metaData.t1GemScr !== undefined
                                                && matchesIn[match.matchId]
                                                .metaData.t1GemScr !== null">
                                                    {{
                                                        formatScore(
                                                            match,
                                                            matchesIn[match.matchId].metaData.t1GemScr,
                                                        )
                                                    }}
                                                </div>
                                                <div class="team-score-item" v-if="matchesIn[match.matchId].metaData.t1Scr != undefined">
                                                    {{matchesIn[match.matchId].metaData.t1Scr}}
                                                </div>
                                                <!--div class="team-score-item" v-for="(period, p) in matchesIn[match.matchId].metaData.periods" :key="p">{{period.t1Scr}}</div-->
                                                </div>
                                                <div class="ggame-live-team-score">
                                                <div class="team-score-item current-score"
                                                v-if="matchesIn[match.matchId]
                                                .metaData.t2GemScr !== undefined
                                                && matchesIn[match.matchId]
                                                .metaData.t2GemScr !== null">
                                                    {{
                                                        formatScore(
                                                            match,
                                                            matchesIn[match.matchId].metaData.t2GemScr,
                                                        )
                                                    }}
                                                </div>
                                                <div class="team-score-item" v-if="matchesIn[match.matchId].metaData.t2Scr != undefined">
                                                    {{matchesIn[match.matchId].metaData.t2Scr}}
                                                </div>
                                                <!--div class="team-score-item" v-for="(period, p) in matchesIn[match.matchId].metaData.periods" :key="p">{{period.t2Scr}}</div-->
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="sportState == 'live'" class="odd-stats-live event-icons">
                                            <FavouriteToggle  :match="matchesIn[match.matchId]" @favouritetoggled="favouritetoggled" />
                                            <!-- TODO removed live tv icon, as there shouldn't yet be live coverage. Remove when task 18920332 is being deployed -->
                                            <!-- div class="stream-icon">
                                                <i class="iconset icon-stream"></i>
                                            </div -->
                                        </div>
                                    </div>
                                </div>
                                <div v-if="match.groups.length == 0
                                || group.outcomes[0] === undefined
                                || group.outcomes[0].marketId === null"
                                class="odds-container sport no-odds-container">
                                    <div class="no-odd-text">{{$t('NOODDSAVAILABLEATTHISMOMENT')}}</div>
                                </div>
                                <div class="odds-container sport" v-else ref_testcafe="oddsContainer">
                                    <div class="odd-value no-odd-new"
                                    v-if="marketId !== 'bonus1'
                                    && marketId !== 'bonus2'
                                    && marketId !== 'favourites'
                                    && sportTree.markets[marketId].hasModifier">
                                        <div class="odd-head">
                                            {{
                                                sportTree.markets[marketId].modifierName
                                                | formatModifierName(
                                                    matchesIn[match.matchId],
                                                    group.outcomes[0].specifiers,
                                                )
                                            }}
                                        </div>
                                        <div class="odd-number">
                                            {{
                                                sportTree.markets[marketId].modifierValue
                                                | formatModifierName(
                                                    matchesIn[match.matchId],
                                                    group.outcomes[0].specifiers,
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="odd-value no-odd-new"
                                    v-else-if="(marketId === 'bonus1'
                                    || marketId === 'bonus2')
                                    && false">
                                        <div class="odd-head">
                                            {{
                                                sportTree.markets[group.outcomes[0].markets[0]].modifierName
                                                | formatModifierName(
                                                    matchesIn[match.matchId],
                                                    group.outcomes[0].specifiers,
                                                )
                                            }}
                                        </div>
                                        <div class="odd-number">
                                            {{
                                                sportTree.markets[group.outcomes[0].markets[0]]
                                                .modifierValue
                                                | formatModifierName(
                                                    matchesIn[match.matchId],
                                                    group.outcomes[0].specifiers,
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <Outcome
                                        v-for="outcome in group.outcomes"
                                        v-bind:outcome="outcome"
                                        v-bind:match="matchesIn[match.matchId]"
                                        v-bind:key="outcome.outcomeId"
                                        v-bind:details="false"></Outcome>
                                </div>

                            </div>
                            <div v-if="matchesIn[match.matchId].matchFooter" class="bonus-info-footer match">{{matchesIn[match.matchId].matchFooter}}</div>
                        </div>
                    </template>
                </div>
                <div class="bonus-info-footer"
                v-if="marketId === 'bonus2'"
                :key="'footer-' + marketId">
                    <img src="../../../assets/img/icon-bonus-info.svg">
                    <p>{{$t('BONUSTWOTOURNAMENTFOOTER')}}</p>
                </div>
                <div class="bonus-info-footer"
                v-if="sportTree.tournaments[item.tournamentId] && sportTree.tournaments[item.tournamentId].tournamentFooter"
                :key="'footer-tournament' + marketId">
                    <p>{{sportTree.tournaments[item.tournamentId].tournamentFooter}}</p>
                </div>
            </template>
        </template>
        <template v-else>
            <template v-for="marketId in item.marketsSelected">
                <div :key="marketId">
                    <div class="ggame-odds-heading">
                        <div class="ggame-odds-lheading">-</div>
                    </div>
                    <template v-for="matchId in item.matches">
                        <div class="ggame-item" :class="{'live': sportState == 'live', 'is-blocked': (matchesIn[matchId].status === 'block' || globalEventBlock[sportState])}" :key="matchId" v-if="matchesIn[matchId]">
                            <div class="ggame-item-content">
                                <div v-if="sportState == 'prematch'" class="ggame-item-text">
                                    <div class="ggame-item-left">
                                        <div class="ggame-inner-top">
                                            <span v-if="item.specialTournament"
                                            class="ggame-heading-icon sport-icon lb-sport"
                                            :class="getSportIconClass(matchesIn[matchId].sportId)">
                                            </span>
                                            <div class="ggame-item-teams">
                                                <span class="first-team">{{matchesIn[matchId].teamNameOne || 'not defined'}} - {{matchesIn[matchId].teamNameTwo || 'not defined'}}</span>
                                            </div>
                                        </div>
                                        <div class="ggame-inner-bottom">

                                            <span class="ggame-item-matchid">-</span>
                                            <span class="ggame-item-date">{{$predefinedLocalDateFormat(matchesIn[matchId].matchDate)}}</span>
                                            <span class="ggame-item-oddscount">+{{matchesIn[matchId].counts.markets}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="ggame-item-text">
                                    <div class="ggame-item-left" v-if="!isMobile">
                                        <div class="ggame-time"></div>
                                        <div class="ggame-teams">
                                            <div class="ggame-live-team">
                                                {{
                                                    matchesIn[matchId].teamNameOne
                                                    || 'not defined'
                                                }}
                                            </div>
                                            <div class="ggame-live-team">
                                                {{
                                                    matchesIn[matchId].teamNameTwo
                                                    || 'not defined'
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ggame-score" v-if="!isMobile">
                                        <div class="ggame-live-team-score"></div>
                                    </div>

                                    <div v-if="isMobile" class="mobile-live-overview">
                                        <div class="ggame-item-left">
                                            <div class="ggame-time">
                                                <div class="ggame-live-time"></div>
                                            </div>
                                            <div class="ggame-teams">
                                                <div class="ggame-live-team">
                                                {{
                                                    matchesIn[matchId].teamNameOne || 'not defined'
                                                }}
                                                </div>
                                                <div class="ggame-live-team">
                                                {{
                                                    matchesIn[matchId].teamNameTwo || 'not defined'
                                                }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ggame-score">
                                            <div class="ggame-live-scores">
                                                <div class="ggame-live-team-score"></div>
                                                <div class="ggame-live-team-score"></div>
                                            </div>
                                        </div>
                                        <div v-if="sportState == 'live'" class="odd-stats-live"></div>
                                    </div>
                                </div>
                                <div class="odds-container sport no-odds-container">
                                    <div class="no-odd-text">{{$t('NOODDSAVAILABLEATTHISMOMENT')}}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="bonus-info-footer"
                v-if="marketId === 'bonus2'"
                :key="'footer-' + marketId">
                    <img src="../../../assets/img/icon-bonus-info.svg">
                    <p>{{$t('BONUSTWOTOURNAMENTFOOTER')}}</p>
                </div>
            </template>
        </template>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { Common } from '@om-retail/vue-common';
import Outcome from '../../components/Outcome.vue';
import FavouriteToggle from '../../components/favourites/FavouriteToggle.vue';

export default {
    name: 'TournamentSingle',
    props: [
        'item',
        'sportMapping',
        'chunkCount',
        'showOddStats',
        'outrightsIn',
        'matchesIn',
    ],
    components:
    {
        Outcome,
        FavouriteToggle,
    },
    data()
    {
        return {
            marketIds: [],
            markets: {},
            initialLoadDone: false,
            matchesIncrements: {},
            tournamentVisible: false,
            outcomeMarkets: {},
            matchesMarkets: {},
        };
    },
    created()
    {
        const me = this;
        const matchesIncrements = {};

        for (const matchId in me.item.matches)
        {
            if (me.item.matches[matchId] != null
            && me.matchesIn[matchId] != null)
            {
                matchesIncrements[matchId] = {
                    increment: me.matchesIn[matchId].increment,
                    isMinOffer: me.matchesIn[matchId].isMinOffer,
                };
            }
        }

        me.matchesIncrements = matchesIncrements;

        me.refreshMarkets();
    },
    methods:
    {
        openBetradarStatsPage(match)
        {
            const me = this;

            const betradarId = match.sConn.match['1'];
            const langCode = me.globals.langCode.split('-')[0];

            const url = `${me.globals.publicConfig.website.betradarStatisticsUrl}/${langCode}/match/${betradarId}`;

            window.open(url, '_blank').focus();
        },
        doesMatchHaveOutright(matchId)
        {
            const me = this;
            let value = false;

            if (me.globals
            && me.globals.publicConfig
            && me.globals.publicConfig.verticalsAvailable
            && me.globals.publicConfig.verticalsAvailable.outrights
            && me.outrightsIn.matchIds.length === 0)
            {
                return false;
            }
            for (const id of me.outrightsIn.matchIds)
            {
                if (String(id) === matchId)
                {
                    value = true;
                    return value;
                }
            }
            return value;
        },
        refreshMarkets()
        {
            const me = this;

            if (!me.tournamentVisible)
            {
                return;
            }

            const markets = { ...me.markets };

            const deleteMarkets = [];

            for (const marketId in markets)
            {
                if (markets[marketId] != null)
                {
                    if (me.item.marketsSelected.indexOf(marketId) === -1)
                    {
                        deleteMarkets.push(marketId);
                    }
                    else
                    {
                        for (let i = 0; i < markets[marketId].matches.length; i += 1)
                        {
                            if (me.item.matches[markets[marketId].matches[i].matchId] == null)
                            {
                                deleteMarkets.push(marketId);
                            }
                        }
                    }
                }
            }

            const marketIdsTemp = [
                ...me.marketIds,
            ];

            for (const marketId of deleteMarkets)
            {
                const index = marketIdsTemp.indexOf(marketId);

                if (index !== -1)
                {
                    marketIdsTemp.splice(
                        index,
                        1,
                    );
                }

                delete (markets[marketId]);
            }

            me.marketIds = marketIdsTemp;

            for (const marketId of me.item.marketsSelected)
            {
                if (markets[marketId] == null)
                {
                    markets[marketId] = {
                        matches: [],
                    };
                }

                for (const matchId in me.item.matches)
                {
                    if (me.item.matches[matchId] != null)
                    {
                        const match = me.matchesIn[matchId];

                        if (match != null)
                        {
                            let matchExists = false;

                            for (const matchTemp of markets[marketId].matches)
                            {
                                if (matchTemp.matchId === matchId)
                                {
                                    matchTemp.groups = me.getGroupsByMatch(match, marketId);
                                    matchExists = true;
                                    break;
                                }
                            }

                            if (!matchExists)
                            {
                                const groupsTemp = me.getGroupsByMatch(match, marketId);

                                if (groupsTemp.length)
                                {
                                    markets[marketId].matches.push({
                                        matchId,
                                        groups: groupsTemp,
                                    });
                                }
                            }
                        }
                    }
                }
            }

            me.markets = Object.assign(markets, {}, {});

            // me.sortEvents();

            // me.sortMarkets();

            me.initialLoadDone = true;
        },
        sortEvents()
        {
            const me = this;

            for (const marketId in me.markets)
            {
                if (me.markets[marketId] != null)
                {
                    const marketGroup = me.markets[marketId];

                    if (marketGroup.matches.length > 1)
                    {
                        marketGroup.matches.stableSort((a, b) =>
                        {
                            const matchOne = me.matchesIn[a.matchId];
                            const matchTwo = me.matchesIn[b.matchId];

                            if (matchOne !== undefined
                            && matchTwo === undefined)
                            {
                                return 1;
                            }

                            if (matchOne === undefined
                            && matchTwo !== undefined)
                            {
                                return -1;
                            }

                            if (matchOne === undefined
                            && matchTwo === undefined)
                            {
                                return 0;
                            }

                            const aStart = moment(matchOne.matchDate);
                            const bStart = moment(matchTwo.matchDate);

                            if (aStart < bStart)
                            {
                                return -1;
                            }

                            if (aStart > bStart)
                            {
                                return 1;
                            }

                            if (matchOne.teamNameOne < matchTwo.teamNameOne)
                            {
                                return -1;
                            }

                            if (matchOne.teamNameOne > matchTwo.teamNameOne)
                            {
                                return 1;
                            }

                            return 0;
                        });
                    }
                }
            }
        },
        getPreselectedMarket(match)
        {
            let firstFound = null;

            if (this.sportTree.marketTree[match.sportId] !== undefined)
            {
                if (this.sportTree.marketTree[match.sportId].markets !== undefined
                && this.sportTree.marketTree[match.sportId].markets.length)
                {
                    for (const marketOut of this.sportTree.marketTree[match.sportId].markets)
                    {
                        if (marketOut.tags !== undefined
                        && marketOut.tags !== null
                        && marketOut.tags.indexOf('preselected') !== -1)
                        {
                            const marketId = parseInt(marketOut.marketId, 10);

                            if (firstFound == null)
                            {
                                firstFound = marketId;
                            }

                            for (const outcome of match.outcomes)
                            {
                                if (outcome.markets.indexOf(marketId) !== -1)
                                {
                                    return marketId;
                                }
                            }
                        }
                    }
                }
            }

            return firstFound;
        },
        getGroupsByMatch(match, marketIdIn)
        {
            const me = this;

            let marketId = marketIdIn;

            if (this.isFavouritesTournament)
            {
                marketId = this.getPreselectedMarket(match);
            }

            const markets = {
                ...me.matchesMarkets[match.matchId],
            };
            let hasOutcomes = false;

            if (marketId != null)
            {
                if (me.matchesMarkets[match.matchId]
                && me.matchesMarkets[match.matchId][marketId]
                && Object.keys(me.matchesMarkets[match.matchId][marketId]).length)
                {
                    hasOutcomes = true;
                }
            }

            let isPreselectedMarket = false;

            if (me.sportTree.marketTree[me.item.sportId] != null
            && me.sportTree.marketTree[me.item.sportId].markets != null)
            {
                for (const market of me.sportTree.marketTree[me.item.sportId].markets)
                {
                    if (market != null
                    && parseInt(market.marketId, 10) === marketId
                    && market.tags != null
                    && market.tags.indexOf('preselected') !== -1)
                    {
                        isPreselectedMarket = true;
                        break;
                    }
                }
            }

            if (!isPreselectedMarket
            && (marketId === 'bonus1'
            || marketId === 'bonus2'
            || this.isFavouritesTournament))
            {
                isPreselectedMarket = true;
            }

            if (!hasOutcomes && isPreselectedMarket)
            {
                if (markets[marketId] === undefined)
                {
                    markets[marketId] = {};
                }

                markets[marketId][''] = {
                    marketId,
                    specHash: '',
                    marketOrder: 10,
                    name: '',
                    outcomes: {
                        outcomeIdTemp: {
                            marketId: null,
                            outcomeId: null,
                            name: '-',
                            value: '-',
                            specHash: '',
                            status: 'active',
                            tags: 'shownInGrid,alwaysShow',
                        },
                    },
                };
            }

            const marketsFin = [];
            for (const specHashTemp in markets[marketId])
            {
                if (markets[marketId][specHashTemp] !== undefined)
                {
                    const group = markets[marketId][specHashTemp];

                    const outcomes = [];
                    for (const outcomeId in group.outcomes)
                    {
                        if (group.outcomes[outcomeId] !== undefined)
                        {
                            outcomes.push(group.outcomes[outcomeId]);
                        }
                    }

                    const outcomesArray = Common.arrayChunk(outcomes, me.chunkCount);

                    let groupTemp = {};
                    for (const outcomeSec of outcomesArray)
                    {
                        groupTemp = { ...groupTemp };
                        groupTemp.outcomes = outcomeSec;

                        if (outcomeSec.length
                        && outcomeSec[0] != null
                        && outcomeSec[0].lineIndex !== undefined)
                        {
                            groupTemp.lineIndex = outcomeSec[0].lineIndex;
                        }

                        marketsFin.push(groupTemp);
                    }
                }
            }

            if (marketsFin.length && marketsFin.length > 1)
            {
                marketsFin.stableSort((a, b) =>
                {
                    const aOutcome = (a.outcomes != null) ? a.outcomes[0] : null;
                    const bOutcome = (b.outcomes != null) ? b.outcomes[0] : null;

                    if (aOutcome == null
                    || bOutcome == null
                    || aOutcome.lineIndex == null
                    || bOutcome.lineIndex == null)
                    {
                        return 0;
                    }

                    if (aOutcome.lineIndex < bOutcome.lineIndex)
                    {
                        return -1;
                    }

                    if (aOutcome.lineIndex > bOutcome.lineIndex)
                    {
                        return 1;
                    }

                    return 0;
                });
            }

            for (let gid = 0; gid < marketsFin.length; gid += 1)
            {
                if (marketsFin[gid].outcomes
                && marketsFin[gid].outcomes.length
                && marketsFin[gid].outcomes.length > 1)
                {
                    marketsFin[gid].outcomes.stableSort((a, b) =>
                    {
                        const aOutcomeOrder = me.sportTree.outcomes[a.outcomeId].orderNum;
                        const bOutcomeOrder = me.sportTree.outcomes[b.outcomeId].orderNum;

                        if (aOutcomeOrder < bOutcomeOrder)
                        {
                            return -1;
                        }

                        if (aOutcomeOrder > bOutcomeOrder)
                        {
                            return 1;
                        }

                        return 0;
                    });
                }
            }

            return marketsFin;
        },
        reloadAllMatchesMarkets(matchesChanged = null)
        {
            const me = this;

            if (!me.tournamentVisible)
            {
                return;
            }

            let matchesMarkets = {
                ...me.matchesMarkets,
            };

            let matchesToCheck = {
                ...me.item.matches,
            };

            if (matchesChanged != null)
            {
                matchesToCheck = {
                    ...matchesChanged,
                };
            }

            if (me.item.sportId === 'bonus')
            {
                matchesMarkets = {};
                matchesToCheck = {
                    ...me.item.matches,
                };
            }

            for (const matchId in matchesToCheck)
            {
                if (matchesToCheck[matchId] != null)
                {
                    if (me.item.matches[matchId] == null)
                    {
                        if (matchesMarkets[matchId] != null)
                        {
                            delete (me.matchesMarkets, matchId);
                        }

                        continue;
                    }

                    const match = me.matchesIn[matchId];

                    if (match != null)
                    {
                        const marketIds = [];
                        let isBonus = false;

                        if (me.item.sportId === 'bonus')
                        {
                            marketIds.push(me.item.tournamentId);
                            isBonus = me.item.tournamentId;
                        }
                        else
                        {
                            for (const marketTemp of match.markets)
                            {
                                marketIds.push(marketTemp.marketId);
                            }
                        }

                        /* if (matchesMarkets[matchId] == null)
                        {
                            matchesMarkets[matchId] = {};
                        } */

                        matchesMarkets[matchId] = {};

                        for (const outcome of match.outcomes)
                        {
                            let outcomeMarketId = outcome.markets[0];
                            const { specHash } = outcome;

                            if (isBonus !== false)
                            {
                                if (outcome.tags.indexOf(isBonus) === -1)
                                {
                                    continue;
                                }

                                outcomeMarketId = me.item.tournamentId;
                            }
                            else if (marketIds.indexOf(outcomeMarketId) === -1
                            || (outcome.status !== 'active' && outcome.status !== 'block'))
                            {
                                continue;
                            }

                            if (matchesMarkets[matchId][outcomeMarketId] == null)
                            {
                                matchesMarkets[matchId][outcomeMarketId] = {};
                            }

                            if (matchesMarkets[matchId][outcomeMarketId][specHash] == null)
                            {
                                matchesMarkets[matchId][outcomeMarketId][specHash] = {
                                    marketOrder: me.sportTree.markets[outcome.markets[0]].orderNum,
                                    name: me.sportTree.markets[outcome.markets[0]].name,
                                    marketId: outcomeMarketId,
                                    outcomes: {},
                                };
                            }

                            matchesMarkets[matchId][outcomeMarketId][specHash].outcomes[outcome.outcomeId] = outcome;
                        }
                    }
                }
            }

            me.matchesMarkets = Object.assign(matchesMarkets, {}, {});
        },
        getServeClass(match)
        {
            const me = this;

            let classOut = '';

            classOut = me.getSportIconClass(match.sportId);

            classOut += ` ${classOut.replace('sporticon-', '')}-serve`;

            return classOut;
        },
        getSportIconClass(sportId)
        {
            const me = this;

            let sportIconName = 'noicon';

            if (me.sportMapping[sportId] !== undefined)
            {
                sportIconName = me.sportMapping[sportId];
            }

            return `sporticon-${sportIconName}`;
        },
        getMarketName(marketId, field = 'name')
        {
            const me = this;
            let nameOut = 'not defined';
            let fieldOut = field;

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field] != null)
            {
                fieldOut = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field];
            }

            if (me.sportTree.markets[marketId] != null
            && me.sportTree.markets[marketId][fieldOut] != null)
            {
                nameOut = me.sportTree.markets[marketId][fieldOut];
            }

            return nameOut;
        },
        getMarketNames()
        {
            const me = this;

            if (me.item.marketsSelected.length === 1)
            {
                if (me.item.marketsSelected[0] == null)
                {
                    return me.$t('NOBETGROUPSELECTED');
                }
                return me.getMarketName(me.item.marketsSelected[0], 'marketSelectorTab');
            }
            if (me.item.marketsSelected.length === me.item.totalMarkets)
            {
                return me.$t('ALL');
            }

            const nullReducer = (me.item.marketsSelected.indexOf(null) !== -1) ? 1 : 0;

            return `${me.item.marketsSelected.length - nullReducer} ${me.$t('SELECTED')}`;
        },
        sortMarkets()
        {
            const me = this;

            const markets = [];

            if (me.markets.favourites)
            {
                markets.push({ marketId: 'favourites' });
            }
            else if (me.markets.bonus1)
            {
                markets.push({ marketId: 'bonus1' });
            }
            else if (me.markets.bonus2)
            {
                markets.push({ marketId: 'bonus2' });
            }
            else if (me.sportTree.marketTree[me.item.sportId] !== undefined)
            {
                if (me.sportTree.marketTree[me.item.sportId].markets !== undefined
                && me.sportTree.marketTree[me.item.sportId].markets.length)
                {
                    for (const market of me.sportTree.marketTree[me.item.sportId].markets)
                    {
                        if (me.markets[market.marketId])
                        {
                            markets.push(market);
                        }
                    }
                }
                markets.stableSort((a, b) =>
                {
                    const aMarkerOrder = a.orderNum;
                    const bMarkerOrder = b.orderNum;

                    if (aMarkerOrder < bMarkerOrder)
                    {
                        return -1;
                    }

                    if (aMarkerOrder > bMarkerOrder)
                    {
                        return 1;
                    }

                    return 0;
                });
            }

            let marketIds = [];

            if (me.item.sportId === 'bonus'
            || me.item.tournamentId === 'favourites') // bonus have numbers...
            {
                marketIds = markets.map((market) => market.marketId);
            }
            else
            {
                marketIds = markets.map((market) => parseInt(market.marketId, 10));
            }
            me.marketIds = marketIds;
        },
        formatScore(match, score)
        {
            const me = this;

            let scoreOut = score;

            if (match !== undefined
            && match.matchId !== undefined
            && me.matchesIn[match.matchId] !== undefined
            && me.globals
            && me.globals.props
            && me.globals.props.sportScoringMapping)
            {
                const matchOut = me.matchesIn[match.matchId];

                if (me.globals.props.sportScoringMapping[matchOut.sportId]
                && me.globals.props.sportScoringMapping[matchOut.sportId][score.toString()] !== undefined)
                {
                    scoreOut = me.$t(me.globals.props.sportScoringMapping[matchOut.sportId][score.toString()]);
                }
            }

            return scoreOut;
        },
        getLiveMinutes(match)
        {
            const me = this;

            let val = Common.formatLiveEventDetails(match);

            if (!val.length
            && (me.matchesIn[match.matchId].metaData.status !== 'NOT_STARTED'
            || (me.matchesIn[match.matchId].metaData.min !== undefined
            && me.matchesIn[match.matchId].metaData.periodStatus !== null)))
            {
                val = me.$t(`WEB_${me.matchesIn[match.matchId].metaData.periodStatus}`);
            }

            return val;
        },
        visibilityChanged(val)
        {
            const me = this;

            if (val && !me.tournamentVisible)
            {
                me.tournamentVisible = val;
            }
        },
        getEventLineClasses(match)
        {
            if (this.isFavouritesTournament)
            {
                return [
                    'lb-sport',
                    'favourites-event-line',
                    `sportbordercolor-${this.sportMapping[match.sportId]}`,
                ];
            }

            return [];
        },
        favouritetoggled(val)
        {
            this.$emit('favouritetoggled', val);
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'sportTree',
            'sportState',
            'globalEventBlock',
            'isMobile',
        ]),
        isFavouritesTournament()
        {
            return this.item.tournamentId === 'favourites';
        },
        getGameHeadingClass()
        {
            if (this.isFavouritesTournament)
            {
                return 'sportbordercolor-undefined';
            }

            return `sportbordercolor-${this.sportMapping[this.item.tournamentId]}`;
        },
    },
    watch:
    {
        'item.matches':
        {
            handler()
            {
                const me = this;
                const matchesChanged = {};
                const newMatches = {};

                if (me.initialLoadDone)
                {
                    let newValues = false;

                    for (const matchId in me.item.matches)
                    {
                        if (me.item.matches[matchId] != null)
                        {
                            if (me.matchesIncrements[matchId] == null
                            || me.item.matches[matchId] !== me.matchesIncrements[matchId].increment
                            || me.matchesIn[matchId] == null
                            || me.matchesIn[matchId].isMinOffer !== me.matchesIncrements[matchId].isMinOffer)
                            {
                                newValues = true;
                                matchesChanged[parseInt(matchId, 10)] = parseInt(matchId, 10);
                                // break;
                            }

                            newMatches[matchId] = {
                                matchId,
                                isMinOffer: (me.matchesIn[matchId] != null) ? me.matchesIn[matchId].isMinOffer : null,
                                increment: me.item.matches[matchId],
                            };
                        }
                    }

                    for (const matchId in me.matchesIncrements)
                    {
                        if (me.matchesIncrements[matchId] != null)
                        {
                            if (me.matchesIncrements[matchId] == null
                            || me.item.matches[matchId] !== me.matchesIncrements[matchId].increment
                            || me.matchesIn[matchId] == null
                            || me.matchesIn[matchId].isMinOffer !== me.matchesIncrements[matchId].isMinOffer)
                            {
                                newValues = true;
                                matchesChanged[parseInt(matchId, 10)] = parseInt(matchId, 10);
                                // break;
                            }

                            newMatches[matchId] = {
                                matchId,
                                isMinOffer: (me.matchesIn[matchId] != null) ? me.matchesIn[matchId].isMinOffer : null,
                                increment: me.item.matches[matchId],
                            };
                        }
                    }

                    if (newValues)
                    {
                        me.matchesIncrements = Object.assign(newMatches, {}, {});
                        me.reloadAllMatchesMarkets(matchesChanged);
                        me.refreshMarkets();
                    }
                }
            },
            deep: true,
            immediate: true,
        },
        'item.marketsSelected.length'()
        {
            const me = this;

            if (me.initialLoadDone)
            {
                // me.reloadAllMatchesMarkets();
                me.refreshMarkets();
            }
        },
        tournamentVisible(val)
        {
            const me = this;

            if (val)
            {
                // me.refreshMarkets();
                me.reloadAllMatchesMarkets();
                me.refreshMarkets();
            }
        },
        markets()
        {
            const me = this;

            me.sortEvents();
            me.sortMarkets();
        },
    },
};
</script>
